import * as ACTION_TYPES from './types';

const initialState = {
  status: {
    loadList: -1,
    loadDetails: -1,
    add: -1,
    update: -1,
    delete: -1,
  },
  records: [],
  details: {},
  deleted: null,
  extras: {
    page: -1,
    pages: -1,
    total: -1,
  },
  error: null,
};

export default function reducer(state = initialState, action) {
  const { type, payload, meta, error } = action;

  switch (type) {
    case ACTION_TYPES.AM_APPLICATIONS_RETRIEVE_REQUESTED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 0,
        },
      };
    case ACTION_TYPES.AM_APPLICATIONS_RETRIEVE_SUCCEED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 1,
        },
        records: payload.result.data,
        extras: {
          ...state.extras,
          total: payload.result.meta.pagination.total,
          page: payload.result.meta.pagination.page,
          pages: payload.result.meta.pagination.pages,
        },
      };
    case ACTION_TYPES.AM_APPLICATIONS_RETRIEVE_FAILED:
      return {
        ...state,
        status: {
          ...state.status,
          loadList: 2,
        },
        error,
      };
    default:
      return state;
  }
}
